const fr = {
  common: {
    wallet: "portefeuille",
    playPage: "jouer",
    minTop: "le montant minimum est de $10",
    maxTop: "le montant maximum est de $500",
    website: "site web",
    signOut: "déconnexion",
    hidden: "caché",
    victory: "victoire",
    wentWrong: "quelque chose s'est mal passé, redirection",
    stakeLabel: "mise",
    howDoes: "comment ça marche ?",
    continue: "Continuer",
    continueWithGoogle: "Continuer avec Google",
    continueWithApple: "Continuer avec Apple",
    termsOfService: "conditions d'utilisation",
    privacyPolicy: "politique de confidentialité",
    termsOfServiceFooter: "conditions d'utilisation",
    privacyPolicyFooter: "politique de confidentialité",
    verificationCode: "code de vérification",
    verify: "vérifier",
    account: "compte",
    error: "une erreur s'est produite\n",
    checkBackLater: "revenez plus tard",
    looking: "recherche...",
    yes: "oui",
    no: "non",
    pleaseSelect: "Veuillez sélectionner\n",
    disclaimer: "en continuant, vous acceptez nos\n",
    and: "et",
  },
  endOfGame: {
    wonByCheckmate: "gagné par échec et mat",
    lostOnTime: "perdu par le temps",
    resigns: "abandonne",
    gameDrawnByAgreement: "partie nulle par accord",
    abandonedTheGame: "a abandonné la partie",
    gameAborted: "partie interrompue",
    gameDrawnByStalemate: "partie nulle par pat",
    gameDrawnByFiftyMoveRule: "partie nulle par la règle des cinquante coups",
    gameDrawnByInsufficientMaterial: "partie nulle par manque de matériel",
    gameDrawnByThreefoldRepetition: "partie nulle par triple répétition",
    draw: "nulle",
    victory: "victoire",
    defeat: "défaite",
    aborted: "interrompu",
    white: "blancs",
    black: "noirs",
    inspectBoard: "voir le plateau",
    returnToEndOfGameModal: "continuer",
  },
  byPhone:{
    continueOnPhone: "continuer sur\ntéléphone",
    or: "ou",
    continueOnWeb: "continuer sur\nle navigateur",
    disclaimer: "conseillé si vous avez une photo de votre pièce d'identité sur disque"
  },
  signUp: {
    email: "email",
    username: "nom d'utilisateur",
    usernameInvalid: "nom d'utilisateur invalide",
    emailInvalid: "email invalide",
    login: "connexion",
    continueWithPhone: "continuer avec le numéro de téléphone",
    tickBoxes: "cochons quelques\ncases",
    confirm: "Je confirme que\n",
    resideIn: "Je réside en\n",
    notPEP: "Je ne suis pas une personne politiquement exposée (PEP), un membre de la famille ou un associé connu d'un PEP\n",
    purpose: "Le but et la nature de ma relation avec Gambit sont exclusivement pour utiliser le service à des fins de divertissement\n",
    soleBenefit: "J'utiliserai le service exclusivement à mon profit et il n'y a pas d'autre bénéficiaire effectif\n",
  },
  identity: {
    beingVerified: "identité\nen cours de vérification",
    verified: "vérifié\n",
    failed: "la vérification\na échoué",
  },
  payment: {
    failed: "le paiement a échoué.\nveuillez réessayer",
    successful: "paiement\nréussi !",
    toppedUp: "vous êtes\nrechargé !",
    topUp: "recharger\n",
    payWith: "payer avec...\n",
  },
  gameplay: {
    play: "jouer\n",
    challenge: "vous défie à",
    gameWorth: "jeu d'une valeur de\n",
    whatsYourNumber: "quel est votre\nnuméro ?",
    receiveCode: "vous recevrez un code de vérification\nsous peu",
    matchedOpponent: "Vous serez apparié avec un adversaire de classement similaire.",
    stake: {
      total: "La mise totale sera le montant sélectionné ci-dessous.",
      contribution: "Vous contribuerez à peu près la moitié de ce montant.",
      weakerOpponent: "Si vous êtes apparié avec un adversaire plus faible, vous paierez une plus grande part de la mise.",
      strongerOpponent: "Si vous êtes apparié avec un adversaire plus fort, vous paierez une plus petite part de la mise.",
    },
    supportInfo: "Visitez notre support pour plus d'informations.\n",
    continueBrowser: "continuez sur\nvotre navigateur",
    continuePhone: "continuez sur\ntéléphone",
    getStarted: "commençons\n",
    sentText: "nous vous avons envoyé\nun texto",
    enterReceivedCode: "entrez le code de vérification\nreçu",
    wrongCode: "code incorrect, essayez à nouveau\n",
    secPerMove: "sec/coup",
    resign: {
      prompt: "êtes-vous sûr de vouloir abandonner ?",
    },
    draw: {
      offer: "accepter l'offre de nulle ?",
    },
    rating: "classement\n",
    balance: "solde\n",
    rematch: "revanche\n",
    newOpponent: "nouvel adversaire\n",
    home: "accueil\n",
    rematchOffer: "votre adversaire propose une revanche. Accepter ?",
    leaveGame: "Vous jouez actuellement une partie. Êtes-vous sûr de vouloir partir ?",
    room: "salle :\n",
    gameTypes: {
      bullet: {
        title: "bullet\n",
        description: "Échecs d'adrénaline. Vous et votre adversaire disposez chacun d'une minute seulement pour gagner la partie.",
      },
      blitz: {
        title: "blitz\n",
        description: "Vous et votre adversaire disposez chacun de trois minutes pour gagner la partie.",
      },
    },
    stakes: {
      unlockNext: "jouez {amount} parties supplémentaires pour débloquer l'enjeu suivant",
      allUnlocked: "vous avez débloqué tous les enjeux",
    },
    withdraw: "retirer\n",
  },
  puzzle: {
    begin: "commencer",
    next: "suivant",
    unavailableInYourRegion: "indisponible",
    puzzle: "énigme",
    whiteToPlay: "blanc à jouer",
    blackToPlay: "noir à jouer",
    time: "temps",
    solution: "solution",
    somethingWentWrong: "quelque chose s'est mal passé",
    rating: "évaluation",
    credits: "crédits",
    puzzleFailed: "défaite",
    puzzleSolved: "victoire",
    correct: "solution correcte",
    incorrect: "solution incorrecte",
    youRanOutOfTime: "vous n'avez plus de temps",
    puzzleDescription: "Vous disposez de 10 secondes + 2 secondes/coup pour résoudre une énigme.",
    creditsLeft: "crédits restants",
    refillIn: "remplir dans",
    lastPuzzle: "c'est votre dernier puzzle, revenez plus tard pour plus.",
    outOfCredits: "vous n'avez plus de crédits, revenez plus tard.",
    locationPrompt: "Nous avons besoin de votre emplacement pour continuer. Si bloqué, veuillez le réactiver :",
    locationInstructions: "Cliquez sur l'icône dans la barre d'adresse, sélectionnez 'Toujours autoriser' et rafraîchissez la page",
    creditsError: "Erreur lors du chargement des crédits",
    moves: "Coups :",
  },
};

export {fr};